"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Persona_1 = __importDefault(require("../Persona/Persona"));
const util_1 = require("../../../util");
const UserBadge = function (prop) {
    const { item, small, size } = prop;
    const l = [];
    if (item.firstName) {
        l.push(item.firstName.charAt(0));
    }
    if (item.lastName) {
        l.push(item.lastName.charAt(0));
    }
    if (l.length === 0) {
        l.push('*');
    }
    let { img } = item;
    if (item.gravatarEmail) {
        img = (0, util_1.getGravatarUrl)(item.gravatarEmail);
    }
    return (react_1.default.createElement("div", { className: "glx-default-text glx-flex glx-flex-r glx-flex-g-6 glx-flex-v-center" },
        react_1.default.createElement(Persona_1.default, { text: l.join(' '), small: small, img: img, size: size }),
        react_1.default.createElement("div", { className: "glx-flex glx-flex-c" },
            react_1.default.createElement("div", null,
                item.firstName,
                " ",
                item.lastName),
            item.subTitle ? react_1.default.createElement("div", null, item.subTitle) : null)));
};
UserBadge.defaultProps = {
    size: undefined,
    small: undefined,
};
exports.default = UserBadge;
